import { Box, Link, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { Row } from "react-bootstrap";
import { BoldLockSlash } from "../../../../Icon";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { EGSpeedDial } from "../../../../MainComponents/Button/SpeedDial/SpeedDial";
import { EGSwitch } from "../../../../MainComponents/Switch/Switch";
import { EGBasicSelect } from "../../../../MainComponents/Select/EGBasicSelect";
import Comments from "../Comments";
import { useTranslation } from "react-i18next";
import { HelpIcon } from "../../../../MainComponents/HelpIcon/HelpIcon";
import { EGInput } from "../../../../MainComponents/Input/EGInput";

export const Blocked = ({
  blockedCategory,
  switches,
  getOut,
  actionsBlocking,
  cancelIndicator,
  hdlSwitchIndicatorChange,
  blockedDetails,
  setBlockedDetails,
  blockSelected,
  setBlockSelected,
  reportDetail,
  editing,
  loading,
  details,
  setDetails,
  saveIndicatorInfo,
}) => {
  const [t] = useTranslation("information");
  const theme = useTheme();

  return (
    <Row
      className={`blocked rounded dyTheme1 dyBorder1 mt-20 px-[8] ${
        reportDetail?.locked?.is_locked && !editing.locked
          ? "confirm py-10"
          : "py-[20]"
      }`}
    >
      <div className="blocked__title ">
        <Stack
          display="flex"
          direction="row"
          justifyContent="start"
          alignItems="center"
          spacing={1}
          sx={{ overflow: "hidden" }}
        >
          <Box sx={{ height: 24, width: 24 }}>
            <BoldLockSlash color={theme.palette.error.main} />
          </Box>

          <Box display="flex" alignItems="center">
            <div>
              <Typography
                style={{ display: "inline" }}
                color={theme.palette.blueGray700.main}
                component="p"
                fontSize={16}
                fontWeight={600}
              >
                {t("information.block_report")}
              </Typography>
              {switches.locked ? (
                <div style={{ display: "inline" }}>
                  <HelpIcon
                    text={t("information.help_icon_blocked_enable")}
                    className="mx-[5] d-inline-block"
                  />
                </div>
              ) : (
                <div style={{ display: "inline" }}>
                  <HelpIcon
                    text={t("information.help_icon_blocked_disable")}
                    className="mx-[5] d-inline-block"
                  />
                </div>
              )}
            </div>
          </Box>
        </Stack>

        {switches.locked ? (
          editing.locked ? (
            <Stack
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexDirection="row"
              flexWrap="nowrap"
              spacing={0.5}
            >
              <EGIconButton
                disabled={loading.locked}
                iconName="check_icon"
                color="success"
                iconColor="white"
                onClick={() => saveIndicatorInfo("locked")}
                title={t("information.save")}
                placement="bottom"
                sx={{ height: 24, width: 24, padding: 0 }}
              />
              <EGIconButton
                disabled={loading.locked}
                iconName="close_icon"
                color="error"
                iconColor="white"
                onClick={() => cancelIndicator("locked")}
                title={t("information.cancel")}
                placement="bottom"
                sx={{ height: 24, width: 24, padding: 0 }}
              />
            </Stack>
          ) : (
            <Stack
              position="absolute"
              top="50%"
              right={12}
              sx={{ transform: "translateY(-50%)" }}
            >
              <EGSpeedDial
                actions={actionsBlocking}
                tooltipPlacement="bottom"
              />
            </Stack>
          )
        ) : (
          <>
            <EGSwitch
              onChange={hdlSwitchIndicatorChange}
              checked={switches.locked}
              id="locked"
              size="small"
            />
          </>
        )}
      </div>

      {switches.locked && (
        <Box marginTop={2}>
          {editing.locked ? (
            <>
              <EGBasicSelect
                value={blockSelected}
                options={blockedCategory}
                onChange={(e) => setBlockSelected(e.target.value)}
              />
              {details.locked ? (
                <>
                  <EGInput
                    id="outlined-multiline-static-detail-blocked-report"
                    label={`${t("information.details")}:`}
                    placeholder={t("information.specify_details_block")}
                    value={blockedDetails}
                    onChange={(e) => setBlockedDetails(e.target.value)}
                    rows={4}
                    className="w-100 mt-3"
                    multiline
                  />
                </>
              ) : (
                <>
                  <Stack display="flex" alignItems="end" marginTop="0.2rem">
                    <Link
                      onClick={() =>
                        setDetails((prev) => ({
                          ...prev,
                          locked: true,
                        }))
                      }
                      underline="hover"
                    >
                      + {t("information.add_details")}
                    </Link>
                  </Stack>
                </>
              )}
            </>
          ) : (
            <div
              className={`blocked__info ${
                getOut.locked && "--getOut"
              } rounded my-1`}
            >
              <h6 className="label m-0">
                {reportDetail?.locked?.comment?.label ||
                  t("information.this_report_is_blocked")}
              </h6>
              {reportDetail?.locked?.message && (
                <div className="comment">
                  <Comments 
                    text={reportDetail?.locked.message} 
                    background="white"
                  />
                </div>
              )}
            </div>
          )}
        </Box>
      )}
    </Row>
  );
};
